import { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

function useSignup() {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [loading, setLoading] = useState(false);

  const Signup = async (payload) => {
    setLoading(true);
    try {
      const res = await axios.post(`${BASE_URL}/api/register/`, payload);
      setLoading(false);
      return { success: true, data: res.data };
    } catch (error) {
      setLoading(false);
      let message =
        "Oops! Something went wrong on our end. Please try again later.";
      if (error?.response?.data) {
        const data = error.response.data;

        if (data.email) {
          message = data.email[0];
        } else if (data.message) {
          message = data.message;
        }
      }

      Swal.fire({
        icon: "error",
        text: message,
        customClass: {
          confirmButton: "custom-red-button",
        },
      });

      return { success: false };
    }
  };

  return { Signup, loading };
}

export default useSignup;
